module.exports = __webpack_public_path__ + "static/apple-touch-icon-72x72-9c80e3b594829a8682eeb9e4e9769718.png";